import { render, staticRenderFns } from "./LabelGroups.vue?vue&type=template&id=3a770028&lang=pug&"
import script from "./LabelGroups.vue?vue&type=script&lang=js&"
export * from "./LabelGroups.vue?vue&type=script&lang=js&"
import style0 from "./LabelGroups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports